<template>
  <b-modal
    ref="modal-settings-payroll"
    :title="$t('Tracking Contributions')"
    modal-class="modal-primary"
    size="lg"
    hide-footer
    scrollable
    @hidden="close"
  >
    <filter-slot
      :paginate="paginate"
      :no-visible-principal-filter="true"
      :filter="[]"
      :filter-principal="{}"
      @reload="$refs['refTrackingTable'].refresh()"
    >
      <template #table>
        <b-table
          ref="refTrackingTable"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="searchSettingsContribution"
          :fields="fields"
          primary-key="id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-1" />
              <strong>Loading ...</strong>
            </div>
          </template>

          <template #head(name)="data">
            <div class="text-center ml-2">
              {{ data.label }}
            </div>
          </template>
          <template #head(value)="data">
            <div class="text-center">
              {{ data.label }}
            </div>
          </template>
          <template #head(created_by)="data">
            <div class="text-center">
              {{ data.label }}
            </div>
          </template>
          <template #head(updated_by)="data">
            <div class="text-center">
              {{ data.label }}
            </div>
          </template>

          <template #cell(name)="data">
            <div
              class="align-middle text-center d-flex justify-content-center mt-1"
            >
              {{ data.item.name }}
            </div>
          </template>

          <template #cell(value)="data">
            <div
              class="align-middle text-center d-flex justify-content-center mt-1"
            >
              {{ data.item.value }}
              {{ data.item.type == "percentage" ? "%" : "" }}
            </div>
          </template>

          <template #cell(created_by)="data">
            <td
              class="align-middle text-center d-flex justify-content-center align-items-center m-0 p-0"
            >
              {{ data.item.created_by }} <br />
              {{ data.item.created_at | myGlobalWithHour }}
            </td>
          </template>

          <template #cell(updated_by)="data">
            <td
              class="align-middle text-center d-flex justify-content-center align-items-center m-0 p-0"
            >
              {{ data.item.update_by }} <br />
              {{ data.item.updated_at | myGlobalWithHour }}
            </td>
          </template>
        </b-table>
      </template>
    </filter-slot>
  </b-modal>
</template>

<script>
import SettingPayrollService from "@/views/settings/views/payroll/services/setting-payroll.service.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

export default {
  components: {
    FilterSlot,
  },
  props: {
    idContribution: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      onControl: false,
      startPage: 0,
      toPage: 0,
      isBusy: false,
      sortBy: "name",
      sortDesc: true,
      searchInput: "",
      fields: [
        {
          key: "name",
          sortable: false,
          label: this.$t("NAME"),
        },
        {
          key: "value",
          sortable: false,
          label: this.$t("NEW VALUE"),
        },
        {
          key: "created_by",
          sortable: false,
          label: this.$t("CREATED BY"),
        },
        {
          key: "updated_by",
          sortable: false,
          label: this.$t("UPDATED BY"),
        },
      ],
      trackingItems: [],
      totalRows: 1,
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  mounted() {
    this.toggleModal("modal-settings-payroll");
  },
  async created() {
    // this.addPreloader();
    // this.removePreloader();
  },

  methods: {
    close() {
      this.$emit("close");
    },

    async searchSettingsContribution(ctx) {
      const response = await SettingPayrollService.searchSettingContribution({
        slug: this.idContribution,
        orderby: "created_at",
        page: ctx.currentPage,
        order: ctx.sortDesc ? "desc" : "asc",
        perPage: ctx.perPage,
      });

      this.trackingItems = response.data.data;
      this.startPage = response.data.from;
      this.paginate.currentPage = response.data.current_page;
      this.paginate.perPage = response.data.per_page;
      this.totalRows = response.data.total;
      this.toPage = response.data.to;
      return this.trackingItems || [];
    },
  },
};
</script>
<style >
.table td > td {
  border-top: none;
}

.table td {
  padding-left: 2px;
  padding-right: 2px;
}
</style>
